"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotesFilters = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var HotjarWrapper_1 = require("../helpers/HotjarWrapper");
var tracker_1 = __importDefault(require("../helpers/tracker"));
var AbstractFilters_1 = require("./AbstractFilters");
var StickyElement_1 = require("./StickyElement");
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var QuotesFilters = /** @class */ (function (_super) {
    __extends(QuotesFilters, _super);
    function QuotesFilters(el, options) {
        var _this = _super.call(this, el, options) || this;
        _this.customEvents = [
            { name: 'click', queries: ['.js-filter-opener'], callback: _this.onOpenFiltersPanel.bind(_this) },
            { name: 'click', queries: ['.js-apply-filters'], callback: _this.onApplySelectedFilters.bind(_this) },
            { name: 'click', queries: ['.js-tab-opener'], callback: _this.onSelectFilterTab.bind(_this) },
            {
                name: 'click',
                queries: ['.js-close-filter-panel', '.js-filters-overlay'],
                callback: _this.onCloseFiltersPanel.bind(_this),
            },
        ];
        _this.options = options;
        _this.stickyOpenButton = new StickyElement_1.StickyElement(_this.filterHolder, StickyElement_1.StickyPosition.TOP);
        _this.activeTabId = _this.getActiveTabId();
        return _this;
    }
    QuotesFilters.prototype.onFilterItemClick = function (e) {
        e.preventDefault();
        var target = e.target;
        var currentTarget = e.currentTarget;
        var filterType = currentTarget.getAttribute('data-facet');
        var filterValue = (0, dom_interact_1.getAttributeFromTargetBubblingUpTo)('data-facet-item', target, currentTarget);
        var url = (0, dom_interact_1.getAttributeFromTargetBubblingUpTo)('href', target, currentTarget);
        if (!filterType) {
            throw new Error('Filter type not found in element');
        }
        // If no value is because clicked on the container and not in a filter value
        if (!filterValue || !url) {
            return;
        }
        this.trackClickOnQuotesFilterValue(filterType, filterValue, url);
    };
    QuotesFilters.prototype.onOpenFiltersPanel = function () {
        this.openFiltersPanel();
        this.trackOpenFiltersPanel();
    };
    QuotesFilters.prototype.onApplySelectedFilters = function () {
        this.closeFiltersPanel();
        this.trackApplySelectedFilters();
    };
    QuotesFilters.prototype.onCloseFiltersPanel = function () {
        this.closeFiltersPanel();
        this.trackCloseFiltersPanel();
    };
    QuotesFilters.prototype.onSelectFilterTab = function (event) {
        var tabElement = event.currentTarget;
        var tabContentId = tabElement.getAttribute('data-tab-id');
        if (!tabContentId || tabContentId === this.activeTabId) {
            return;
        }
        this.activeTabId = tabContentId;
        this.setActiveTab(tabElement);
        this.trackClickOnFilterTab();
    };
    QuotesFilters.prototype.openFiltersPanel = function () {
        this.filterHolder.classList.add('is-open');
        document.body.classList.add('is-desktop-page-fixed');
        (0, HotjarWrapper_1.hotJarTrigger)('filters-panel-open');
    };
    QuotesFilters.prototype.closeFiltersPanel = function () {
        this.filterHolder.classList.remove('is-open');
        document.body.classList.remove('is-desktop-page-fixed');
        (0, HotjarWrapper_1.hotJarTrigger)('filters-panel-closed');
    };
    QuotesFilters.prototype.setActiveTab = function (tabElement) {
        var contentElement = (0, dom_interact_1.getHTMLElement)(this.el, "#".concat(this.activeTabId));
        var activeTabsAndContainers = this.el.querySelectorAll('.is-active');
        for (var i = 0; i < activeTabsAndContainers.length; i++) {
            activeTabsAndContainers[i].classList.remove('is-active');
        }
        tabElement.classList.add('is-active');
        contentElement.classList.add('is-active');
    };
    QuotesFilters.prototype.getActiveTabId = function () {
        return (0, dom_interact_1.getHTMLElement)(this.el, '.js-tab-content.is-active').id;
    };
    QuotesFilters.prototype.trackOpenFiltersPanel = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_OPEN_PANEL,
        });
    };
    QuotesFilters.prototype.trackCloseFiltersPanel = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_CLOSE_PANEL,
        });
    };
    QuotesFilters.prototype.trackClickOnFilterTab = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_TAB_CLICK,
            label: this.activeTabId,
        });
    };
    QuotesFilters.prototype.trackApplySelectedFilters = function () {
        tracker_1.default.track({
            category: this.options.trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_FILTER_RESULTS_CLICK,
        });
    };
    QuotesFilters.prototype.trackClickOnQuotesFilterValue = function (filterType, filterValue, url) {
        tracker_1.default.trackAndNavigate({
            category: this.options.trackingCategory,
            action: "filter_".concat(filterType),
            label: filterValue,
        }, url);
    };
    return QuotesFilters;
}(AbstractFilters_1.AbstractFilters));
exports.QuotesFilters = QuotesFilters;
